export default function () {
  // https://inclusive-components.design/collapsible-sections/
  const accordions: NodeList | null = document.querySelectorAll(".accordion");
  if (accordions) {
    // Get all the <h2> headings
    accordions.forEach((accordion: Node, i: number): void => {
      const _accordion = accordion as HTMLElement;
      const headings: NodeList | null =
        _accordion.querySelectorAll(".accordion > h2");
      // console.log('heading', headings);

      Array.prototype.forEach.call(headings, (heading) => {
        // Give each <h2> a toggle button child
        // with the SVG plus/minus icon
        heading.innerHTML = `
						<button aria-expanded="false">
							${heading.textContent}
							<span>&minus;</span>
							<span>&plus;</span>
						</button>
					`;

        // Function to create a node list
        // of the content between this <h2> and the next
        const getContent = (elem: any) => {
          let elems = [];
          while (
            elem.nextElementSibling &&
            elem.nextElementSibling.tagName !== "H2" &&
            elem.nextElementSibling.tagName !== "H3"
          ) {
            elems.push(elem.nextElementSibling);
            elem = elem.nextElementSibling;
          }

          // Delete the old versions of the content nodes
          elems.forEach((node) => {
            node.parentNode.removeChild(node);
          });

          return elems;
        };

        // Assign the contents to be expanded/collapsed (array)
        let contents = getContent(heading);

        // Create a wrapper element for `contents` and hide it
        let wrapper = document.createElement("div");
        wrapper.hidden = true;

        // Add each element of `contents` to `wrapper`
        contents.forEach((node) => {
          wrapper.appendChild(node);
        });

        // Add the wrapped content back into the DOM
        // after the heading
        heading.parentNode.insertBefore(wrapper, heading.nextElementSibling);

        // Assign the button
        let btn = heading.querySelector("button");

        btn.onclick = () => {
          // Cast the state as a boolean
          let expanded = btn.getAttribute("aria-expanded") === "true" || false;

          // Switch the state
          btn.setAttribute("aria-expanded", !expanded);
          // Switch the content's visibility
          wrapper.hidden = expanded;
        };
      });
    });
  }
}
